/* eslint-disable react/no-multi-comp */
/* eslint-disable react/jsx-pascal-case */
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';

import UIDateFormater, {
  DateType,
} from '../../containers/UIhelper/UIDateFormater';
// import BIAS from './BIAS';
import SensorsNoiseGraph from './SensorsNoiseGraph';
import SpectrogramGraph from './SpectrogramGraph';
import GraphsConditionsLegend from './GraphsConditionsLegend';
import CorrelationGraph from './CorrelationGraph';

function PreviousGraps(props, context) {

  const [columns, setColumns] = React.useState(() =>
    window.devicePixelRatio >= 1 ? 4 : window.devicePixelRatio >= 0.8 ? 5 : 6
  );

  React.useEffect(() => {
    const handleResize = () => {
      const dpr = window.devicePixelRatio;

      setColumns(dpr >= 0.75 ? 4 : dpr >= 0.6 ? 5 : dpr >= 0.4 ? 6 : 7);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const includedArr = React.useMemo(() => {
    const included = props.analysisData[0]?.included_indexes15?.included_arr;
    const conditions = props.analysisData[0]?.bias_results?.condition_distance;
    const result = included?.filter((arr, index) => Boolean(conditions?.[index]));
    return result || []    
  }, [props.analysisData[0]])

  
  const getTitle = (index) => {
    const relatedItem = props.historyNoiseData[index];
    let strValue = '--';
    if (relatedItem != null) {
      const date = UIDateFormater(
        relatedItem[0],
        DateType.SHORT_DATE,
        props.timeZone,
        props.projectTimeZone
      );
      const sensor1Nc1 = relatedItem[1] ? relatedItem[1] : '--';
      const sensor2Nc1 = relatedItem[2] ? relatedItem[2] : '--';
      const sensor1Nc2 = relatedItem[3] ? relatedItem[3] : '--';
      const sensor2Nc2 = relatedItem[4] ? relatedItem[4] : '--';

      strValue = `#${index} ${date}, Nc1/Nc2: ${sensor1Nc1}/${sensor1Nc2}, ${sensor2Nc1}/${sensor2Nc2}`;
    }
    return strValue;
  };

  const getHistoryParams = (index) => {
    const relatedItem = props.historyNoiseData[index];

    const data = {
      date: '--',
      s1Nc1: '--',
      s1Nc2: '--',
      s2Nc1: '--',
      s2Nc2: '--',
    };
    if (relatedItem != null) {
      data.date = UIDateFormater(
        relatedItem[0],
        DateType.SHORT_DATE,
        props.timeZone,
        props.projectTimeZone
      );
      data.s1Nc1 = relatedItem[1] ? relatedItem[1] : '--';
      data.s2Nc1 = relatedItem[2] ? relatedItem[2] : '--';
      data.s1Nc2 = relatedItem[3] ? relatedItem[3] : '--';
      data.s2Nc2 = relatedItem[4] ? relatedItem[4] : '--';
    }
    return data;
  };

  const Cell = (props) => (
    <TableCell style={{ color: 'white' }} align='center' {...props}>
      {props.value}
    </TableCell>
  );

  return (
    <div>
      <div className='history-graphs' style={{ display: 'grid', gridTemplateColumns: `repeat(${columns}, 1fr)`, gap: '16px' }}>
        {props.displayType === 'instance' && (
          <Box className='prev-graphs-with-tooltip'>
          <SensorsNoiseGraph
            title={context.t('noise_NC1_NC2')}
            titleY={context.t('intensity')}
            titleX={context.t('date')}
            historyNoiseData={props.historyNoiseData}
            timeZone={props.timeZone}
            small
          />
          </Box>
        )}
          <Box className='prev-graphs-with-tooltip'>
          <SpectrogramGraph
            graphTitle={context.t('avg_max_spectrogram')}
            titleSize={11}
            data={Array.isArray(props.histogramAve) ? props.histogramAve : []}
            xValues={{
              start: props.graphParams.freq.start,
              step: props.graphParams.freq.step,
            }}
            yAxisLabels={props.graphsDistancesForAxis}
            xTitle={context.t('frequency')}
            yTitle={context.t('distance')}
            small
          />
        </Box>
        {props.displayType === 'avg' && (
          <Box className='prev-graphs-with-tooltip'>
            <CorrelationGraph
              title={context.t('name_correlation', { name: 'Instance' })}
              data={[props.correlationInstance]}
              factor={props.graphParams.factor}
              xTitle={context.t('distance')}
              yTitle={context.t('contrast')}
              xAxisLabels={props.graphsDistancesForAxis}
              small
            />

          </Box>

        )}
        {/* {props.bias && props.bias[0] && (
          <Box className='prev-graphs-with-tooltip'>
          <BIAS
            title={'bias'}
            data={props.bias}
            xTitle={context.t('bands')}
            yTitle={context.t('days')}
            small
            hoverMode
          />
          </Box>
        )} */}

      <Box className='prev-graphs-with-tooltip big'>
        <GraphsConditionsLegend config={props.analysisData[0]?.bias_results} />
        </Box>

        {/* todo lia 263 */}

        {props.historyData &&
          props.historyData?.map((itrData, index) => {
            const included = itrData.included;
            // const includedConditions = props.analysisData[0]?.included_indexes15?.included_arr;
            const conditionsLabels = [];

            includedArr?.forEach((conditionNames, cNdx) => {
              if (conditionNames.includes(index)) {
                conditionsLabels.push(cNdx)
              }
            });

            const itrDate = UIDateFormater(
              itrData.date,
              DateType.DATE_AND_TIME_WITH_SECONDS,
              props.timeZone,
              props.projectTimeZone
            );
            const params = getHistoryParams(index);

            const tooltipContent = (
              <Box>
                <Typography variant='h4' component='h4' align='center'>
                  {itrDate}
                </Typography>
                <Divider
                  style={{ background: 'white', opacity: 0.4 }}
                  variant='middle'
                  light
                />
                <Table aria-label={context.t('sensors_nc_table')} size='small'>
                  <TableHead>
                    <TableRow>
                      <Cell />
                      <Cell value='Sensor 1' />
                      <Cell value='Sensor 2' />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <Cell component='th' scope='row' value='Nc1' />
                      <Cell value={params.s1Nc1} />
                      <Cell value={params.s2Nc1} />
                    </TableRow>
                    <TableRow>
                      <Cell component='th' scope='row' value='Nc2' />
                      <Cell value={params.s1Nc2} />
                      <Cell value={params.s2Nc2} />
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>
            );

            return (
              <Tooltip
                key={index}
                className='prev-graphs-with-tooltip'
                placement='top'
                enterDelay={1000}
                title={tooltipContent}
              >
                <div>
                  <SpectrogramGraph
                    graphTitle={getTitle(index)}
                    titleSize={11}
                    data={Array.isArray(itrData.histogram) ? itrData.histogram : []}
                    xValues={{
                      start: props.graphParams.freq.start,
                      step: props.graphParams.freq.step,
                    }}
                    yAxisLabels={props.graphsDistancesForAxis}
                    xTitle={context.t('frequency')}
                    yTitle={context.t('distance')}
                    small
                    // included={included}
                  />
                  <span style={{
                    position: 'relative',
                    display: 'inline-block',
                    bottom: '77%',
                    textAlign: 'end',
                    right: `25px`,
                    color: '#fff',
                    borderRadius: '5px',
                    padding: '2px',
                    zIndex: 5,
                    width: '100%'
                  }}>
                    {conditionsLabels?.map((x) => x+1).join(', ')}
                  </span>
                </div>
              </Tooltip>
            );
          })}
      </div>
    </div>
  );
}

PreviousGraps.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default PreviousGraps;
